import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { from, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppService } from '../../app.service';
import { CacheService } from '../../cache.service';
import {CookieService} from 'ngx-cookie';
@Injectable({
  providedIn: 'root'
})
export class BackendStatusGuard  {
  constructor(private appService: AppService, private router: Router, 
    private cacheService: CacheService, private cookieService: CookieService) {

  }
  // tslint:disable-next-line:max-line-length
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    const backendStatus = this.cookieService.get('backendStatus')
    if(backendStatus) {
      return true
    } else {
      return from(this.appService.getServiceStatus()).pipe(
        map(value => {
          this.cacheService.put('backendStatus', 'RUNNING', {expires: '1'})
          return true;
        }),
        catchError((error: any) => {
          if (error.status >= 500 || error.status === 0) {
            this.appService.maintenanceMode$.next(true);
            return of(false);
          } else {
            this.cacheService.put('backendStatus', 'RUNNING', {expires: '1'})
            return of(true);
          }
        })
      );
    }
  }
}
